const { Core, Events } = Global;

const CN_LOADING = '!loading';
const ATTR_VARIANT_ID = 'variant-id';

customElements.define('product-to-cart', class extends Core {
    elements = {
        $: ['to-cart-button']
    }

    propTypes = {
        'form-child': Boolean
    }

    render() {
        this.$({click: this._onClick});
        this.sub(Events.CART_UPDATE, this._cartUpdateHandler, { global: true });
        this.sub(Events.CART_ERROR, this._cartUpdateHandler, { global: true });
    }

    _onClick(e) {
        !this.prop('form-child') && e.preventDefault();
        this.loading = true;
        setTimeout(() => {
            this.loading = false;
        },500);

         let valid = true;
if(this.prop('form-child')){
// Get all visible required elements
const parentContainer = this.closest('[data-element="product-meta"]');
if(parentContainer){
const requiredFields = Array.from(parentContainer.querySelectorAll('[required]'))
  .filter(el => el.offsetParent !== null); // visible check

requiredFields.forEach(el => {
  if (!el.checkValidity() || !el.value) valid = false;
});

if (!valid) {

  requiredFields.forEach(el => {
    const parentP = el.closest('p');
    if (!parentP) return;

    if (!el.checkValidity() || !el.value) {
      parentP.classList.add('errored');
    } else {
      parentP.classList.remove('errored');
    }
  });

  // Prepend error message
  const container = parentContainer.querySelector('product-to-cart');
  if (container) {
    // Remove existing duplicate messages first
    const existing = container.querySelector('.error');
    if (existing) existing.remove();

    const msg = document.createElement('p');
    msg.className = 'error';
    msg.innerHTML = `
      <strong style="color:red;font-weight:bold;margin-bottom:10px;display:block;">
        *Please fill out required fields above.
      </strong>
    `;
    container.prepend(msg);
  }

} else {
  document.querySelectorAll('.error').forEach(el => el.style.display = 'none');
}
}
}


        !this.prop('form-child') && this.addToCart(this.cartItem);
    }

    addToCart(items) {
        this.pub(Events.CART_ADD, {
            items
        });
    }

    _cartUpdateHandler() {
        setTimeout(() => {
            this.loading = false
        }, 1500)
    }

    get cartItem() {
        return [{ 
            id: this.variantId,
            quantity: 1
        }]
    }
    
    set loading(state) {
        this.$('to-cart-button').classList.toggle(CN_LOADING, state);
    }

    set variantId(id) {
        this.setAttribute(ATTR_VARIANT_ID, id)
    }

    get variantId() {
        return +this.getAttribute(ATTR_VARIANT_ID)
    }
})